module.exports = __webpack_public_path__ + "img/bg-open_lecture_sp.e5fcb89f.jpg";